import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

const Card = ({ as, to, href, title, text, cta, className = '', children }) => {
  const cls = `cy-card ${className}`.trim();
  const body = (
    <>
      {title ? <h3 className="cy-card-title">{title}</h3> : null}
      {text ? <p className="cy-card-text">{text}</p> : null}
      {children}
      {cta ? (
        <span className="cy-card-arrow">
          {cta} <FiArrowRight aria-hidden="true" />
        </span>
      ) : null}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={`${cls} cy-card--link`}>
        {body}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={`${cls} cy-card--link`}>
        {body}
      </a>
    );
  }
  return <div className={cls}>{body}</div>;
};

export default Card;
